import Calendly from './components/portfolio/Calendly';

// @ts-expect-error TS2339: Property 'dataLayer' does not exist on type 'Window & typeof globalThis'.
window.dataLayer = window.dataLayer || [];

const chat = new Calendly('js-calendly');
chat.registerButtonListener();
